import { createRouter, createWebHistory } from 'vue-router'
// import HomePage from './views/HomePage.vue'
// import ClientesMigracao from '@/modules/migracoes/clientes/ClientesMigracao.vue'
// import PlanosView from '@/modules/planos/PlanosView.vue'
// import PlanosViewPro from '@/modules/planos/PlanosViewPro.vue'
// import PlanosViewProBasic from '@/modules/planos/PlanosViewProBasic.vue'
// import PlanosViewProPlus from '@/modules/planos/PlanosViewProPlus.vue'
// import PlanosViewThyago from '@/modules/planos/PlanosViewThyago.vue'
// import PlanosViewProfiAutos from '@/modules/planos/PlanosViewProfiAutos.vue'
import PlanosViewDeg from '@/modules/planos/PlanosViewDeg.vue'
import PlanoBasic from '@/modules/planos/PlanoBasic.vue'
import PlanoPlus from '@/modules/planos/PlanoPlus.vue'
// import Login from '@/modules/acesso/Login.vue'
// import Manager from '@/modules/acesso/Manager.vue'
// import LayoutPrincipal from '@/modules/layouts/LayoutPrincipal.vue'

const routes = [
  // {
  //   path: '/',
  //   name: 'home',
  //   redirect: 'planos',
  //   component: HomePage
  // },
  // {
  //   path: '/migracoes/clientes',
  //   name: 'migracoes-clientes',
  //   component: ClientesMigracao
  // },
  // {
  //   path: '/planos',
  //   name: 'planos',
  //   component: PlanosView
  // },
  // {
  //   path: '/promocional',
  //   name: 'promocional',
  //   component: PlanosViewPro
  // },
  // {
  //   path: '/promocionalbasic',
  //   name: 'promocionalbasic',
  //   component: PlanosViewProBasic
  // },
  // {
  //   path: '/promocionalplus',
  //   name: 'promocionalplus',
  //   component: PlanosViewProPlus
  // },
  // {
  //   path: '/thyago',
  //   name: 'thyago',
  //   component: PlanosViewThyago
  // },
  // {
  //   path: '/profiautos',
  //   name: 'profiautos',
  //   component: PlanosViewProfiAutos
  // },
  {
    path: '/planodeg',
    name: 'planodeg',
    component: PlanosViewDeg
  },
  // {
  //   path: '/login',
  //   name: 'login',
  //   component: Login
  // },
  // {
  //   path: '/manager',
  //   name: 'manager',
  //   component: Manager
  // },
  // {
  //   path: '/pagedefault',
  //   name: 'pagedefault',
  //   component: LayoutPrincipal
  // },
  {
    path: '/planobasic',
    name: 'planobasic',
    component: PlanoBasic
  },
  {
    path: '/planoplus',
    name: 'planoplus',
    component: PlanoPlus
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router